import { render } from "./Novedades.vue?vue&type=template&id=a1c35bfc&scoped=true"
import script from "./Novedades.vue?vue&type=script&lang=js"
export * from "./Novedades.vue?vue&type=script&lang=js"

import "./Novedades.vue?vue&type=style&index=0&id=a1c35bfc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1c35bfc"]])

export default __exports__